<script setup lang="ts">
const { trackEvent } = useGAnalytics();

import { useXPixel } from "~/composables/useXPixel";
//const { proxy } = useScriptXPixel()
const { loadXPixel, trackEventXPixel } = useXPixel();
onMounted(() => {
  loadXPixel();
});
const sendXPixelConversion_OpenApplyForm = () => {
  trackEvent("tw-on8c3-q3dzo");
  if (typeof window?.twq === "function") {
    trackEventXPixel("tw-on8c3-q3dzo");
  } else {
    trackEvent("tw-on8c3-q3dzo-BLOCKED-BY-CLIENT");
    console.warn(
      "Twitter Pixel tw-on8c3-q3e1g not loaded or blocked by client."
    );
  }
};
</script>

<template>
  <div
    class="relative flex-1 sm:min-w-[400px] flex flex-col min-h-full w-full rounded-lg border border-primary-900 sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 bg-linear-to-r from-primary-900 from-50% md:from-40% to-transparent">
    <img
      src="/img/influencer.old.webp"
      alt="Influencer"
      class="absolute inset-0 -z-100 w-full h-full object-cover mx-auto" />
    <div class="px-6 py-7 flex flex-col justify-center">
      <p class="text-neutral-200 text-[42px] font-bold">
        {{ $t("main.referrals.notInfluencerTitle") }}
      </p>
      <p class="text-neutral-300 text-2xl font-bold mt-2">
        {{ $t("main.referrals.notInfluencerSubtitle") }}
      </p>
      <div class="md:self-start mt-4 flex flex-col items-center gap-0.5">
        <div class="text-primary-500 text-7xl font-bold leading-none">25%</div>
        <div class="text-neutral-200 font-normal leading-none">
          {{ $t("main.referrals.revenue") }}
        </div>
        <div class="text-primary-500 text-2xl font-bold leading-none">
          {{ $t("main.referrals.months") }}
        </div>
        <div class="text-neutral-200 text-lg font-normal leading-none">
          {{ $t("main.referrals.signup") }}
        </div>
      </div>

      <p class="text-neutral-300 text-lg max-w-[704px] mt-6">
        {{ $t("main.referrals.notInfluencerDescription") }}
      </p>
      <p class="text-neutral-300 text-lg mt-4">
        {{ $t("main.referrals.notInfluencerInstructions") }}
      </p>

      <a
        href="https://docs.google.com/forms/d/1LFC9ZP-wNh-qcwbtvLGnEeoEYYOxbIYF6DxZ9OoN2hI/viewform?edit_requested=true"
        target="_blank"
        rel="noopener"
        class="min-w-full"
        @click="sendXPixelConversion_OpenApplyForm">
        <BaseButtonSubmit
          :text="$t('main.referrals.notInfluencerGetStarted')"
          size="xl"
          class="md:w-80 my-6" />
      </a>

      <div class="flex flex-col md:flex-row gap-2 md:gap-0">
        <NuxtLinkLocale
          to="/legal/influencer-program-terms-conditions"
          target="_blank"
          rel="noopener"
          class="text-xs text-primary-300 hover:text-primary-500 underline"
          >{{
            $t("main.referrals.notInfluencerLinkMarketplace")
          }}</NuxtLinkLocale
        >
        <span class="text-neutral-300 text-xs mx-1 hidden md:block">|</span>
        <NuxtLinkLocale
          to="https://gfal.com/legal/influencer-program-terms-conditions/"
          target="_blank"
          rel="noopener"
          external
          class="text-xs text-primary-300 hover:text-primary-500 underline"
          >{{ $t("main.referrals.notInfluencerLinkGames") }}</NuxtLinkLocale
        >
      </div>
    </div>
  </div>
</template>
